<div class="header-bar">
  <h1>Customer Steps & Photos</h1>
</div>
<div class="content-container">
  <form (ngSubmit)="search()" style="width: 100%">
    <div class="ui-g filterPanel">
      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <span class="md-inputfield filterItem">
          <input name="name" type="text" pInputText [(ngModel)]="filterVal.filters.name.value" />
          <label>Name</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <span class="md-inputfield filterItem">
          <input
            name="addressLine1"
            type="text"
            pInputText
            [(ngModel)]="filterVal.filters.addressLine1.value"
          />
          <label>Address</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <span class="md-inputfield filterItem">
          <input name="town" type="text" pInputText [(ngModel)]="filterVal.filters.town.value" />
          <label>Town</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <span class="md-inputfield filterItem">
          <input
            name="postcode"
            type="text"
            pInputText
            [(ngModel)]="filterVal.filters.postcode.value"
          />
          <label>Postcode</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <button pButton type="submit" label="Search"></button>
        <button pButton type="button" label="Clear" (click)="clearFilter(dt)"></button>
      </div>
    </div>
  </form>

  <p-table
    #dt
    selectionMode="single"
    [(selection)]="selectedItem"
    [value]="page.items"
    [totalRecords]="page.total"
    [rows]="filterVal.rows"
    [first]="filterVal.first"
    [sortField]="filterVal.sortField"
    [sortOrder]="filterVal.sortOrder"
    [paginator]="true"
    [rowsPerPageOptions]="[5, 10, 20]"
    [pageLinks]="3"
    [lazy]="true"
    (onLazyLoad)="onGridLazyLoad($event)"
    [responsive]="true"
    [rowHover]="true"
    [resizableColumns]="true"
    [loading]="isBusy"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn pSortableColumn="name">Name</th>
        <th pResizableColumn pSortableColumn="addressLine1">Address</th>
        <th pResizableColumn pSortableColumn="town">Town</th>
        <th pResizableColumn pSortableColumn="postcode">Postcode</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr [pSelectableRow]="item" (dblclick)="goToDetails()">
        <td>{{ item.name }}</td>
        <td>{{ item.addressLine1 }}</td>
        <td>{{ item.town }}</td>
        <td>{{ item.postcode }}</td>
      </tr>
    </ng-template>
  </p-table>

  <!-- DEPRECATED --
        <p-dataTabl #dt selectionMode="single" [(selection)]="selectedItem"
                     [value]="page.items" [totalRecords]="page.total"
                     [rows]="filterVal.rows" [first]="filterVal.first"
                     [sortField]="filterVal.sortField" [sortOrder]="filterVal.sortOrder"
                     [paginator]="true" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3"
                     [lazy]="true" (onLazyLoad)="onGridLazyLoad($event)"
                     [responsive]="true" [rowHover]="true" [resizableColumns]="true"
                     (onRowDblclick)="goToDetails()"
                     [loading]="isBusy">
            <p-column field="name" header="Name" [sortable]="tru" [editable]="false"></p-column>
            <p-column field="addressLine1" header="Address" [sortable]="tru" [editable]="false"></p-column>
            <p-column field="town" header="Town" [sortable]="tru" [editable]="false"></p-column>
            <p-column field="postcode" header="Postcode" [sortable]="tru" [editable]="false"></p-column>
        </p-dataTable>
        -->

  <div class="footerPanel ui-grid-row">
    <button
      class="btn-to-right"
      type="button"
      (click)="goToDetails()"
      label="Edit"
      pButton
      icon="fa ui-icon-mode-edit"
      [disabled]="!selectedItem"
    ></button>
  </div>
</div>
